import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminOrganizationsByOrganizationIdEncounterTypes: build.query<
      GetV2AdminOrganizationsByOrganizationIdEncounterTypesApiResponse,
      GetV2AdminOrganizationsByOrganizationIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/encounter-types`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdEncounterTypes: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdEncounterTypesApiResponse,
      PostV2AdminOrganizationsByOrganizationIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/encounter-types`,
        method: "POST",
        body: queryArg.encounterTypeCreate,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/encounter-types/${queryArg.encounterTypeId}`,
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "PATCH",
          body: queryArg.encounterTypeUpdate,
        }),
      }),
    getV2AdminProvidersByProviderIdEncounterTypes: build.query<
      GetV2AdminProvidersByProviderIdEncounterTypesApiResponse,
      GetV2AdminProvidersByProviderIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/encounter-types`,
      }),
    }),
    postV2AdminProvidersByProviderIdEncounterTypes: build.mutation<
      PostV2AdminProvidersByProviderIdEncounterTypesApiResponse,
      PostV2AdminProvidersByProviderIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/encounter-types`,
        method: "POST",
        body: queryArg.encounterTypeCreate,
      }),
    }),
    deleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse,
        DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/providers/${queryArg.providerId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeId:
      build.query<
        GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse,
        GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/providers/${queryArg.providerId}/encounter-types/${queryArg.encounterTypeId}`,
        }),
      }),
    patchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse,
        PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/providers/${queryArg.providerId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "PATCH",
          body: queryArg.encounterTypeUpdate,
        }),
      }),
    getV2ProviderEncounterTypes: build.query<
      GetV2ProviderEncounterTypesApiResponse,
      GetV2ProviderEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounter-types`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          provider_id: queryArg.providerId,
        },
      }),
    }),
    postV2ProviderEncounterTypes: build.mutation<
      PostV2ProviderEncounterTypesApiResponse,
      PostV2ProviderEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounter-types`,
        method: "POST",
        body: queryArg.encounterTypeCreate,
      }),
    }),
    deleteV2ProviderEncounterTypesByEncounterTypeId: build.mutation<
      DeleteV2ProviderEncounterTypesByEncounterTypeIdApiResponse,
      DeleteV2ProviderEncounterTypesByEncounterTypeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounter-types/${queryArg.encounterTypeId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderEncounterTypesByEncounterTypeId: build.query<
      GetV2ProviderEncounterTypesByEncounterTypeIdApiResponse,
      GetV2ProviderEncounterTypesByEncounterTypeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounter-types/${queryArg.encounterTypeId}`,
      }),
    }),
    patchV2ProviderEncounterTypesByEncounterTypeId: build.mutation<
      PatchV2ProviderEncounterTypesByEncounterTypeIdApiResponse,
      PatchV2ProviderEncounterTypesByEncounterTypeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounter-types/${queryArg.encounterTypeId}`,
        method: "PATCH",
        body: queryArg.encounterTypeUpdate,
      }),
    }),
    getV2ProviderOrganizationsByOrgIdEncounterTypes: build.query<
      GetV2ProviderOrganizationsByOrgIdEncounterTypesApiResponse,
      GetV2ProviderOrganizationsByOrgIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types`,
      }),
    }),
    postV2ProviderOrganizationsByOrgIdEncounterTypes: build.mutation<
      PostV2ProviderOrganizationsByOrgIdEncounterTypesApiResponse,
      PostV2ProviderOrganizationsByOrgIdEncounterTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types`,
        method: "POST",
        body: queryArg.encounterTypeCreate,
      }),
    }),
    getV2ProviderOrganizationsByOrgIdEncounterTypesAll: build.query<
      GetV2ProviderOrganizationsByOrgIdEncounterTypesAllApiResponse,
      GetV2ProviderOrganizationsByOrgIdEncounterTypesAllApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types/all`,
      }),
    }),
    postV2ProviderOrganizationsByOrgIdEncounterTypesBatchArchive:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdEncounterTypesBatchArchiveApiResponse,
        PostV2ProviderOrganizationsByOrgIdEncounterTypesBatchArchiveApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types/batch-archive`,
          method: "POST",
          body: queryArg.encounterTypeBatchArchiveRequest,
        }),
      }),
    postV2ProviderOrganizationsByOrgIdEncounterTypesCleanupApply:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdEncounterTypesCleanupApplyApiResponse,
        PostV2ProviderOrganizationsByOrgIdEncounterTypesCleanupApplyApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types/cleanup-apply`,
          method: "POST",
          body: queryArg.encounterTypeCleanupApplyRequest,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdEncounterTypesCleanupBootstrap:
      build.query<
        GetV2ProviderOrganizationsByOrgIdEncounterTypesCleanupBootstrapApiResponse,
        GetV2ProviderOrganizationsByOrgIdEncounterTypesCleanupBootstrapApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types/cleanup-bootstrap`,
        }),
      }),
    deleteV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        DeleteV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiResponse,
        DeleteV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "DELETE",
        }),
      }),
    patchV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeId:
      build.mutation<
        PatchV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiResponse,
        PatchV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/encounter-types/${queryArg.encounterTypeId}`,
          method: "PATCH",
          body: queryArg.encounterTypeUpdate,
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminOrganizationsByOrganizationIdEncounterTypesApiResponse =
  /** status 200 OK */ ListResponseEncounterTypeResponse;
export type GetV2AdminOrganizationsByOrganizationIdEncounterTypesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdEncounterTypesApiResponse =
  /** status 201 Created */ EncounterTypeResponse2;
export type PostV2AdminOrganizationsByOrganizationIdEncounterTypesApiArg = {
  organizationId: string;
  encounterTypeCreate: EncounterTypeCreate;
};
export type DeleteV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiResponse =
  unknown;
export type DeleteV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    organizationId: string;
    encounterTypeId: string;
  };
export type GetV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type GetV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    organizationId: string;
    encounterTypeId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type PatchV2AdminOrganizationsByOrganizationIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    organizationId: string;
    encounterTypeId: string;
    encounterTypeUpdate: EncounterTypeUpdate;
  };
export type GetV2AdminProvidersByProviderIdEncounterTypesApiResponse =
  /** status 200 OK */ ListResponseEncounterTypeResponse;
export type GetV2AdminProvidersByProviderIdEncounterTypesApiArg = {
  providerId: string;
};
export type PostV2AdminProvidersByProviderIdEncounterTypesApiResponse =
  /** status 201 Created */ EncounterTypeResponse2;
export type PostV2AdminProvidersByProviderIdEncounterTypesApiArg = {
  providerId: string;
  encounterTypeCreate: EncounterTypeCreate;
};
export type DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse =
  unknown;
export type DeleteV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    providerId: string;
    encounterTypeId: string;
  };
export type GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type GetV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    providerId: string;
    encounterTypeId: string;
  };
export type PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type PatchV2AdminProvidersByProviderIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    providerId: string;
    encounterTypeId: string;
    encounterTypeUpdate: EncounterTypeUpdate;
  };
export type GetV2ProviderEncounterTypesApiResponse =
  /** status 200 OK */ EncounterTypeListResponse;
export type GetV2ProviderEncounterTypesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Provider ID to list encounter types for (admin only, defaults to self) */
  providerId?: string | null;
};
export type PostV2ProviderEncounterTypesApiResponse =
  /** status 201 Created */ EncounterTypeResponse2;
export type PostV2ProviderEncounterTypesApiArg = {
  encounterTypeCreate: EncounterTypeCreate;
};
export type DeleteV2ProviderEncounterTypesByEncounterTypeIdApiResponse =
  unknown;
export type DeleteV2ProviderEncounterTypesByEncounterTypeIdApiArg = {
  encounterTypeId: string;
};
export type GetV2ProviderEncounterTypesByEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type GetV2ProviderEncounterTypesByEncounterTypeIdApiArg = {
  encounterTypeId: string;
};
export type PatchV2ProviderEncounterTypesByEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type PatchV2ProviderEncounterTypesByEncounterTypeIdApiArg = {
  encounterTypeId: string;
  encounterTypeUpdate: EncounterTypeUpdate;
};
export type GetV2ProviderOrganizationsByOrgIdEncounterTypesApiResponse =
  /** status 200 OK */ EncounterTypeListResponse;
export type GetV2ProviderOrganizationsByOrgIdEncounterTypesApiArg = {
  orgId: string;
};
export type PostV2ProviderOrganizationsByOrgIdEncounterTypesApiResponse =
  /** status 201 Created */ EncounterTypeResponse2;
export type PostV2ProviderOrganizationsByOrgIdEncounterTypesApiArg = {
  orgId: string;
  encounterTypeCreate: EncounterTypeCreate;
};
export type GetV2ProviderOrganizationsByOrgIdEncounterTypesAllApiResponse =
  /** status 200 OK */ EncounterTypeListResponse;
export type GetV2ProviderOrganizationsByOrgIdEncounterTypesAllApiArg = {
  orgId: string;
};
export type PostV2ProviderOrganizationsByOrgIdEncounterTypesBatchArchiveApiResponse =
  /** status 200 OK */ EncounterTypeBatchArchiveResponse;
export type PostV2ProviderOrganizationsByOrgIdEncounterTypesBatchArchiveApiArg =
  {
    orgId: string;
    encounterTypeBatchArchiveRequest: EncounterTypeBatchArchiveRequest;
  };
export type PostV2ProviderOrganizationsByOrgIdEncounterTypesCleanupApplyApiResponse =
  /** status 200 OK */ EncounterTypeCleanupApplyResponse;
export type PostV2ProviderOrganizationsByOrgIdEncounterTypesCleanupApplyApiArg =
  {
    orgId: string;
    encounterTypeCleanupApplyRequest: EncounterTypeCleanupApplyRequest;
  };
export type GetV2ProviderOrganizationsByOrgIdEncounterTypesCleanupBootstrapApiResponse =
  /** status 200 OK */ CleanupBootstrapResponse;
export type GetV2ProviderOrganizationsByOrgIdEncounterTypesCleanupBootstrapApiArg =
  {
    orgId: string;
  };
export type DeleteV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiResponse =
  unknown;
export type DeleteV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    orgId: string;
    encounterTypeId: string;
  };
export type PatchV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiResponse =
  /** status 200 OK */ EncounterTypeResponse2;
export type PatchV2ProviderOrganizationsByOrgIdEncounterTypesAndEncounterTypeIdApiArg =
  {
    orgId: string;
    encounterTypeId: string;
    encounterTypeUpdate: EncounterTypeUpdate;
  };
export type FormRuleSchema = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeResponse = {
  /** Canonical service-type slug stamped on created encounters */
  canonical_service_type?: string | null;
  /** Color identifier for appointment display (color1, color2, etc.) */
  color: string;
  /** Creation timestamp */
  created_at?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules */
  default_form_rules?: FormRuleSchema[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default appointment label IDs for this encounter type */
  default_label_ids?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules */
  default_reminder_rules?: ReminderRuleSchema[] | null;
  /** Default JotMeet delivery setting for video appointments */
  default_use_jotmeet?: boolean | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** UUID of the encounter type */
  encounter_type_id: string;
  /** UUID of the organization */
  organization_id?: string | null;
  /** Scope: 'provider' or 'organization' */
  owner_scope?: string;
  /** ID of the org encounter type this was forked from */
  parent_encounter_type_id?: string | null;
  /** UUID of the provider (None for org-scoped) */
  provider_id?: string | null;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type ListResponseEncounterTypeResponse = {
  items: EncounterTypeResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type FormRuleSchema2 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema2 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeResponse2 = {
  /** Canonical service-type slug stamped on created encounters */
  canonical_service_type?: string | null;
  /** Color identifier for appointment display (color1, color2, etc.) */
  color: string;
  /** Creation timestamp */
  created_at?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules */
  default_form_rules?: FormRuleSchema2[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default appointment label IDs for this encounter type */
  default_label_ids?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules */
  default_reminder_rules?: ReminderRuleSchema2[] | null;
  /** Default JotMeet delivery setting for video appointments */
  default_use_jotmeet?: boolean | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** UUID of the encounter type */
  encounter_type_id: string;
  /** UUID of the organization */
  organization_id?: string | null;
  /** Scope: 'provider' or 'organization' */
  owner_scope?: string;
  /** ID of the org encounter type this was forked from */
  parent_encounter_type_id?: string | null;
  /** UUID of the provider (None for org-scoped) */
  provider_id?: string | null;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type FormRuleSchema3 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema3 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeCreate = {
  /** Canonical service-type slug stamped on created encounters */
  canonical_service_type?: string | null;
  /** Color identifier for appointment display (color1, color2, etc.). If not provided, will be auto-assigned based on encounter type name. */
  color?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules for this encounter type */
  default_form_rules?: FormRuleSchema3[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default appointment label IDs auto-applied to new appointments of this type */
  default_label_ids?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules for this encounter type */
  default_reminder_rules?: ReminderRuleSchema3[] | null;
  /** Default JotMeet delivery setting for video appointments */
  default_use_jotmeet?: boolean | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
};
export type FormRuleSchema4 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema4 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeUpdate = {
  /** Canonical service-type slug stamped on created encounters */
  canonical_service_type?: string | null;
  /** Color identifier for appointment display (color1, color2, etc.) */
  color?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules for this encounter type */
  default_form_rules?: FormRuleSchema4[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default appointment label IDs auto-applied to new appointments of this type */
  default_label_ids?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules for this encounter type */
  default_reminder_rules?: ReminderRuleSchema4[] | null;
  /** Default JotMeet delivery setting for video appointments */
  default_use_jotmeet?: boolean | null;
  /** Name/description of the encounter type */
  encounter_type?: string | null;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
};
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type FormRuleSchema5 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema5 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type EncounterTypeResponse3 = {
  /** Canonical service-type slug stamped on created encounters */
  canonical_service_type?: string | null;
  /** Color identifier for appointment display (color1, color2, etc.) */
  color: string;
  /** Creation timestamp */
  created_at?: string | null;
  /** Default CPT codes to pre-populate encounters of this type */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes */
  default_duration?: number | null;
  /** Default form rules */
  default_form_rules?: FormRuleSchema5[] | null;
  /** Default ICD-10 codes for encounters of this type */
  default_icd10_codes?: string[] | null;
  /** Default appointment label IDs for this encounter type */
  default_label_ids?: string[] | null;
  /** Default modality for encounters of this type */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code (e.g., '11', '10', '02') */
  default_place_of_service?: string | null;
  /** Default reminder rules */
  default_reminder_rules?: ReminderRuleSchema5[] | null;
  /** Default JotMeet delivery setting for video appointments */
  default_use_jotmeet?: boolean | null;
  /** Name/description of the encounter type */
  encounter_type: string;
  /** UUID of the encounter type */
  encounter_type_id: string;
  /** UUID of the organization */
  organization_id?: string | null;
  /** Scope: 'provider' or 'organization' */
  owner_scope?: string;
  /** ID of the org encounter type this was forked from */
  parent_encounter_type_id?: string | null;
  /** UUID of the provider (None for org-scoped) */
  provider_id?: string | null;
  /** Default telehealth setting for appointments of this type */
  telehealth?: boolean | null;
  /** Associated template ID */
  template_id?: string | null;
  /** Last update timestamp */
  updated_at?: string | null;
};
export type EncounterTypeListResponse = {
  /** List of encounter types */
  items: EncounterTypeResponse3[];
  /** Current page number */
  page: number;
  /** Number of items per page */
  per_page: number;
  /** Total number of encounter types */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type BatchArchiveSkippedTemplate = {
  /** Why it was skipped: still_referenced, not_user_scoped, or already_archived. */
  reason: string;
  /** Note template id */
  template_id: string;
};
export type BatchArchiveSkippedType = {
  /** Encounter type id */
  encounter_type_id: string;
  /** Why it was skipped: already_archived, not_archived, or deleted. */
  reason: string;
};
export type EncounterTypeBatchArchiveResponse = {
  /** Note template ids actually archived. */
  archived_template_ids: string[];
  /** Encounter type ids actually archived. */
  archived_type_ids: string[];
  /** Encounter type ids actually restored. */
  restored_type_ids: string[];
  /** Provenance run id covering every action in this apply. */
  run_id: string;
  /** Requested template ids skipped by the server-side guard. */
  skipped_templates: BatchArchiveSkippedTemplate[];
  /** Requested type ids that were idempotent no-ops. */
  skipped_types: BatchArchiveSkippedType[];
};
export type EncounterTypeBatchArchiveRequest = {
  /** User-scoped note template ids the wizard computed as freed (no longer referenced by any type). Advisory: the server re-verifies the reference count and skips still-referenced ids. */
  archive_template_ids?: string[];
  /** Encounter type ids to archive (soft, reversible). */
  archive_type_ids?: string[];
  /** Archived encounter type ids to restore. */
  restore_type_ids?: string[];
};
export type CleanupApplyMergedGroup = {
  /** The keeper the losers folded into. */
  keeper_id: string;
  /** Whether the keeper's name/defaults were updated this run. */
  keeper_updated: boolean;
  /** Type ids merged into the keeper this run. */
  merged_ids: string[];
};
export type CleanupApplyPromotedPair = {
  /** Sibling type ids merged into the winner this run. */
  merged_ids: string[];
  /** Whether the winner's user note template was promoted this run. */
  template_promoted: boolean;
  /** The promoted winner (org scope). */
  winner_id: string;
};
export type CleanupApplySkipped = {
  /** The skipped encounter type (or promoted-template) id. */
  encounter_type_id: string;
  /** Why it was skipped: e.g. pair_set_aside_excluded, wizard_already_converged, pair_winner_already_org, org_merge_keeper_noop. */
  reason: string;
};
export type EncounterTypeCleanupApplyResponse = {
  /** Per-group outcomes for the org-merge resolutions. */
  merged_groups: CleanupApplyMergedGroup[];
  /** Per-pair outcomes for the pair-promotion resolutions. */
  promoted_pairs: CleanupApplyPromotedPair[];
  /** Provenance run id covering every action in this apply. */
  run_id: string;
  /** Rows skipped across all resolutions, with reasons. */
  skipped: CleanupApplySkipped[];
};
export type CleanupApplyReconciledDefaults = {
  /** Raw default_action_rules JSONB (form_rules/reminder_rules). */
  default_action_rules?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes. */
  default_cpt_codes?: string[] | null;
  /** Default appointment duration in minutes. */
  default_duration?: number | null;
  /** Default ICD-10 codes. */
  default_icd10_codes?: string[] | null;
  /** Default modality. */
  default_modality?: ("in_person" | "video" | "audio") | null;
  /** Default CMS place of service code. */
  default_place_of_service?: string | null;
  /** Default telehealth setting. */
  telehealth?: boolean | null;
};
export type CleanupApplyOrgMerge = {
  /** Copy the full behavior-field defaults wholesale from this merged loser onto the keeper. Mutually exclusive with reconciled_defaults. */
  adopt_defaults_from_id?: string | null;
  /** Optional rename applied to the keeper. */
  keep_name?: string | null;
  /** The org-scoped type every loser folds into. */
  keeper_id: string;
  /** Types merged into the keeper (org- or provider-scoped). */
  loser_ids: string[];
  /** Field-wise reconciled defaults to fold onto the keeper. Mutually exclusive with adopt_defaults_from_id. */
  reconciled_defaults?: CleanupApplyReconciledDefaults | null;
};
export type CleanupApplyPairPromotion = {
  /** The full personal cluster. The merge set is member_ids minus the winner minus set_aside_ids. */
  member_ids: string[];
  /** Cluster members excluded from the merge (they stay personal and are provenance-recorded as skips). */
  set_aside_ids?: string[] | null;
  /** Optional rename applied to the promoted winner. */
  shared_name?: string | null;
  /** The provider-scoped type to promote to org scope. */
  winner_id: string;
};
export type EncounterTypeCleanupApplyRequest = {
  /** Org-merge resolutions (GDN-2293). */
  org_merges?: CleanupApplyOrgMerge[];
  /** Pair-promotion resolutions (GDN-2292). */
  pair_promotions?: CleanupApplyPairPromotion[];
};
export type CleanupBootstrapActionRule = {
  /** ISO 8601 duration (e.g. '-P1D'). */
  offset: string;
  /** Display title, if any. */
  title?: string | null;
};
export type CleanupBootstrapActionRules = {
  /** Form-send rule offsets/titles, if any. */
  form_rules?: CleanupBootstrapActionRule[] | null;
  /** Reminder-send rule offsets/titles, if any. */
  reminder_rules?: CleanupBootstrapActionRule[] | null;
};
export type CleanupBootstrapGroup = {
  /** The group's canonical encounter_type_id, if any. */
  canonical?: string | null;
  /** lower(trim(name)) group key. */
  name_key: string;
};
export type CleanupBootstrapPlan = {
  /** Planned action for this row. */
  action: "promote" | "merge" | "skip";
  /** Bucket reason (e.g. canonical_provider_row). */
  reason: string;
};
export type CleanupBootstrapRow = {
  /** Archived (GDN-2227) — restore candidate. */
  archived: boolean;
  color?: string | null;
  default_action_rules?: CleanupBootstrapActionRules | null;
  default_cpt_codes?: string[] | null;
  default_duration?: number | null;
  default_icd10_codes?: string[] | null;
  default_modality?: ("in_person" | "video" | "audio") | null;
  default_place_of_service?: string | null;
  /** Display name of the type. */
  encounter_type: string;
  encounter_type_id: string;
  group?: CleanupBootstrapGroup | null;
  /** Most recent appointment/note (ISO). Future values (upcoming appointments) are a deliberate recency signal and not clamped. */
  last_used_at?: string | null;
  /** 'provider' or 'organization'. */
  owner_scope: string;
  plan?: CleanupBootstrapPlan | null;
  /** Provider display name; null for org-scoped rows. */
  provider?: string | null;
  telehealth?: boolean | null;
  template_id?: string | null;
  template_scope?: ("user" | "org" | "public") | null;
  template_title?: string | null;
  /** appointments + shadow_notes referencing it. */
  usage: number;
};
export type CleanupBootstrapResponse = {
  /** Organization display name. */
  org: string;
  /** Provenance string, e.g. 'live 2026-07-07'. */
  source: string;
  /** Every encounter type (all scopes, archived included). */
  types: CleanupBootstrapRow[];
};
